window.vngage={info:{application:"Workspace",branch:"master",build:"4.8.36",buildTime:"2024-09-09T12:19:39+00:00"}};